import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFSelect from '../../controls/tempRHFControls/RHFSelect';
// import { useDispatch } from 'react-redux';
// import actions from 'src/actions';
import DialogList from 'src/dialogs';
// import ExcelFileDialog from './ExcelFileDialog';

interface IVendorReportsDialogProps {
    dialogName: string;
    handleCategories?: (category: string, subcategory: string) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
}

const VendorReportsDialog = (props: IVendorReportsDialogProps) => {
    // const dispatch = useDispatch();
    const { register, errors } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('VendorReportsDialog onCreate()');
    };

    const reports = () => {
        props.hideDialog();
        props.showDialog(DialogList.EXCEL_FILE);
    };

    const OKClicked = () => {
        // props.handleCategories(getValues('category'), getValues('subcategory'));
        props.hideDialog();
    };

    return (
        <Dialog title="Vendor Reports" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '25%' }}>
            <div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <RHFSelect
                        name={`report`}
                        label="Report"
                        options={[
                            { value: 'A/P Vendor List', label: 'A/P Vendor List' },
                        ]}
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '20rem' }}
                    />
                    <RHFSelect
                        name={`sortBy`}
                        label="Sort By"
                        options={[
                            { value: 'Vendor Number', label: 'Vendor Number' },
                        ]}
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '20rem', marginTop: '1rem' }}
                    />
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Excel Report'}
                    onClick={() => reports()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
            </div>
        </Dialog>
    );
};

export default VendorReportsDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/VendorReportsDialog.tsx